// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__91X2c","right":"styles_right__13BpD"};